import { useEffect, useCallback, useRef } from 'react';
import { requestFullscreen, exitFullscreen, getFullscreenElement, addFullscreenChangeListener, } from '../utils/fullscreenCompat';
const FULLSCREEN_CLASS = 'hekate-player-fullscreen-wrapper';
export function useFullscreen(fullscreenTarget, dispatch, onFullscreenChange, videoElement) {
    // Use a ref so toggleFullscreen is stable across renders
    const targetRef = useRef(null);
    targetRef.current = fullscreenTarget;
    const videoRef = useRef(null);
    videoRef.current = videoElement ?? null;
    const toggleFullscreen = useCallback(() => {
        if (!targetRef.current)
            return;
        if (getFullscreenElement()) {
            exitFullscreen();
        }
        else {
            requestFullscreen(targetRef.current, videoRef.current);
        }
    }, []);
    const enterFullscreenMode = useCallback(() => {
        if (!targetRef.current || getFullscreenElement())
            return;
        requestFullscreen(targetRef.current, videoRef.current);
    }, []);
    const exitFullscreenMode = useCallback(() => {
        if (!getFullscreenElement())
            return;
        exitFullscreen();
    }, []);
    useEffect(() => {
        const handleChange = () => {
            const isFs = !!getFullscreenElement();
            dispatch(isFs ? { type: 'ENTER_FULLSCREEN' } : { type: 'EXIT_FULLSCREEN' });
            onFullscreenChange?.(isFs);
            // Imperatively toggle the CSS class on the wrapper element
            // (it's outside the React tree, so we can't use JSX className)
            if (targetRef.current) {
                if (isFs) {
                    targetRef.current.classList.add(FULLSCREEN_CLASS);
                }
                else {
                    targetRef.current.classList.remove(FULLSCREEN_CLASS);
                }
            }
        };
        const cleanup = addFullscreenChangeListener(handleChange);
        return () => {
            cleanup();
            // Safety: remove class if tearing down while fullscreen
            targetRef.current?.classList.remove(FULLSCREEN_CLASS);
        };
    }, [dispatch, onFullscreenChange]);
    return { toggleFullscreen, enterFullscreen: enterFullscreenMode, exitFullscreen: exitFullscreenMode };
}
